import { render, staticRenderFns } from "./MenuBox.vue?vue&type=template&id=33f72760&scoped=true&"
import script from "./MenuBox.vue?vue&type=script&lang=ts&"
export * from "./MenuBox.vue?vue&type=script&lang=ts&"
import style0 from "./MenuBox.vue?vue&type=style&index=0&id=33f72760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f72760",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
